module.exports = __webpack_public_path__ + "static/media/icons_instagramwhite.ec9f201c.svg";